<template>
    <footer class="text-center">
        <p>Powered by Conexa Saúde / CNPJ 27.092.748/0001-18</p>
    </footer>
</template>

<script>
export default {
    name: 'footer',
}
</script>